import { useCallback, useEffect } from 'react';
export const useKeybind = ({ onOpenSimListDialog, onHelpClick, onMapDashboardClick, onZTHDashboardClick, onZ3KDashboardClick, is_staff, account_id, show_map, show_zth_dashboard, has_paid_tariff, openKeyboardShortcuts, openDebugMeDialog, }) => {
    const keyupHandler = useCallback((e) => {
        if (e.target instanceof HTMLInputElement ||
            e.target instanceof HTMLTextAreaElement)
            return;
        if (e.shiftKey) {
            switch (e.code) {
                case 'Slash':
                    openKeyboardShortcuts();
                    break;
                default:
            }
            return;
        }
        switch (e.code) {
            case 'KeyI':
                ENABLE_SIM && onOpenSimListDialog();
                break;
            case 'KeyH':
                onHelpClick();
                break;
            case 'KeyQ':
                if (is_staff) {
                    window.location.href = `${window.ZONT_URL.cp ?? 'cp'}/users/${account_id}`;
                }
                break;
            case 'KeyD':
                if (is_staff) {
                    openDebugMeDialog();
                }
                break;
            case 'KeyM':
                if (show_map) {
                    onMapDashboardClick();
                }
                break;
            case 'KeyB':
                if (show_zth_dashboard) {
                    onZTHDashboardClick();
                }
                if (has_paid_tariff) {
                    onZ3KDashboardClick();
                }
                break;
            case 'Slash':
                openKeyboardShortcuts();
                break;
            default:
        }
    }, []);
    useEffect(() => {
        document.addEventListener('keyup', keyupHandler);
        return () => {
            document.removeEventListener('keyup', keyupHandler);
        };
    }, []);
};
